import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Customer } from '../customer/customer';
import { CustomerService } from '../customer/customer.service';
import { ArticleService } from '../article/article.service';
import { Article } from '../article/article';
import { Order, OrderPos } from '../order/order';
import { OrderService } from '../order/order.service';
import { Message, SelectItem } from 'primeng/primeng';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.css']
})
export class OrderDetailComponent implements OnInit {

  order: Order;
  msgs: Message[];
  private isEdit: boolean;
  articleList: SelectItem[];
  customerList: SelectItem[];
  articleDescr : string[];
  selectedPosition :  OrderPos;


  constructor(private route: ActivatedRoute, private router: Router,
    private orderService: OrderService, private customerService: CustomerService,
    private articleService: ArticleService) {
    this.order = new Order();
    this.msgs = [];
    this.isEdit = false;
    this.articleList = [{label:"Auswahl",value:""}];
    this.customerList = [];
    this.order.customerid = 0;
    this.order.state = 10;
    this.order.created = new Date();
    this.articleDescr = [];
  }

  ngOnInit() {
    // Here we go, we need to check if there was an id passed. if so, we 
    // have to query order details to enable edit of order.
    if (this.route.snapshot.params['id'] != null) {
      this.orderService.qryOrder(+this.route.snapshot.params['id']).subscribe(
        (order: Order) => {
          if (order != null) {
            this.order = order;
            this.isEdit = true;
          } else {
            this.msgs.push({ severity: 'warn', summary: 'Failed to load order.' });
          }
        },
        (err) => {
          this.msgs = [];
          this.msgs.push({ severity: 'warn', summary: 'Failed to load order.' })
        }
      );
    }

    // Load customers for select menue
    this.customerService.list().subscribe(
      (customerList: Customer[]) => {
        if (customerList != null) {
          for (var customer of customerList) {
            this.customerList.push({ value: customer.id, label: customer.customerid + ' - ' + customer.name1 });
          }
        } else {
          console.log("Couldn't load customers. Please contact customer support.");
        }
      },
      (err) => {
        console.log("Couldn't load customers. Please contact customer support.");
        console.log(err);
      }
    );
    // Load articles for select menue
    this.articleService.list().subscribe(
      (articleList: Article[]) => {
        if (articleList != null) {
          for (var article of articleList) {
            let item: SelectItem = { value: article.id, label: article.articleNumber + ' - ' };
            /**
             * Select correct descript for article name 1.
             * At this point we only have a default description,
             * so that simply this is selected.
             */
            for (var descr of article.descr) {
              if (descr.langCode == 'def') {
                item.label = item.label + descr.name1;
                this.articleDescr[article.id] = item.label;
              }
            }
            this.articleList.push(item);
          }
        } else {
          console.log("Couldn't load customers. Please contact customer support.");
        }
      },
      (err) => {
        console.log("Couldn't load customers. Please contact customer support.");
        console.log(err);
      }
    );
  }



  /**
   * Saves order.
   */
  public onSubmit() {
    if (!this.isEdit) {
      this.orderService.save(this.order).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Wareneingang wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.router.navigateByUrl('/order');
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Wareneingang konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save order, error msg: ' + err);
        }
      );
    } else {
      // set updated date to current date
      this.order.updated = new Date();

      this.orderService.update(this.order).subscribe(
        (res) => {
          let msg: Message = { severity: 'info', detail: 'Der Wareneingang wurde gespeichert.', summary: 'Gespeichert!' };
          this.msgs = [];
          this.msgs.push(msg);
          this.router.navigateByUrl('/order');
        },
        (err) => {
          let msg: Message = { severity: 'warn', detail: 'Der Wareneingang konnte nicht gespeichert werden.', summary: 'Fehler!' };
          this.msgs = [];
          this.msgs.push(msg);
          console.log('Could not save order, error msg: ' + err);
        }
      );
    }
  }

  public addPosition() {
    if (this.order.positions == null)
      this.order.positions = [];
    let pos: OrderPos = new OrderPos();
    pos.userid = this.order.userid;
    pos.version = 0;
    pos.order = this.order.order;
    pos.id = 0;
    pos.articleid = 0;
    pos.state = 10;
    pos.created = new Date();
    pos.updated = new Date();
    pos.pos = 1+'';

    /**
     * Get maximum value of pos. and add one
     */
    for (var p of this.order.positions) {
      if(+p.pos >= +pos.pos)
        pos.pos = (+p.pos + 1)+'';
    }

    this.order.positions = [...this.order.positions, pos];
  }

  private equalPositions(p1: OrderPos, p2 :OrderPos) : boolean {
    return p1.id == p2.id && p1.articleid == p2.articleid && p1.pos == p2.pos && p1.qtyExpected == p2.qtyExpected
      && p1.qtyReceived == p2.qtyReceived && p1.order == p2.order && p1.reservationCode == p2.reservationCode 
      && p1.userid == p2.userid && p1.version == p2.version && p1.state == p2.state;
  }

  public deleteSelectedPosition() {
    if(this.selectedPosition == null)
    {
      this.msgs = [];
      let msg: Message = { severity: 'info', summary: 'Keine Auswahl.', detail: 'Es wurde keine Position ausgewaehlt.' };
      this.msgs.push(msg);
      return;
    }

    let posArray : OrderPos[] = [];
    for(var pos of this.order.positions)
    {
      if(!this.equalPositions(pos, this.selectedPosition)) {
        posArray.push(pos);
      }
    }
    this.order.positions = posArray;
    this.selectedPosition = null;
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/order-detail/order-detail.component.ts